"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerColors = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

exports.SpinnerColors = ['Gray', 'Blue', 'White'];
var colorMap = {
  Blue: '#2b96ed',
  Gray: '#495056',
  White: '#fff'
};

function Spinner(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      colorType = _ref$color === void 0 ? 'Blue' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size;
  var color = colorMap[colorType];
  return jsx_runtime_1.jsxs("svg", Object.assign({
    className: className,
    style: {
      background: 'rgb(255, 255, 255, 0)',
      shapeRendering: 'auto'
    },
    width: size,
    height: size,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid"
  }, {
    children: [jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(0 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.9230769230769231s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(27.692307692307693 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.8461538461538461s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(55.38461538461539 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.7692307692307693s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(83.07692307692308 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.6923076923076923s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(110.76923076923077 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.6153846153846154s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(138.46153846153845 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.5384615384615384s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(166.15384615384616 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.46153846153846156s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(193.84615384615384 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.38461538461538464s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(221.53846153846155 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.3076923076923077s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(249.23076923076923 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.23076923076923078s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(276.9230769230769 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.15384615384615385s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(304.61538461538464 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.07692307692307693s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("g", Object.assign({
      transform: "rotate(332.3076923076923 50 50)"
    }, {
      children: jsx_runtime_1.jsx("rect", Object.assign({
        x: "47",
        y: "12",
        rx: "3",
        ry: "3.6",
        width: "6",
        height: "18",
        fill: color
      }, {
        children: jsx_runtime_1.jsx("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "0s",
          repeatCount: "indefinite"
        }, void 0)
      }), void 0)
    }), void 0)]
  }), void 0);
}

exports.default = Spinner;